import { render, staticRenderFns } from "./FatherView.vue?vue&type=template&id=969026da&"
import script from "./FatherView.vue?vue&type=script&lang=js&"
export * from "./FatherView.vue?vue&type=script&lang=js&"
import style0 from "./FatherView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports